export default __webpack_public_path__ + "images/7c1c2dbb27f3bd1f2b15dea80f686054.svg";